import React from 'react';
import { useTheme } from 'styled-components';
import Form from '../../../../../form';
import { TFormVariant } from '../../../../../form/Form.types';
import { InputIconSC } from './input-icon.styled';

interface InputIconProps {
  Icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  variant?: TFormVariant;
}

const InputIcon: React.FunctionComponent<InputIconProps> = ({ Icon, variant }) => {
  const theme = useTheme();
  const settings = Form.useFormSettings({ variant });

  return (
    <InputIconSC>
      <Icon
        width={24}
        height={24}
        color={
          settings.variant === 'on-dark' ? theme.color.tint.tertiaryDark : theme.color.tint.tertiary
        }
      />
    </InputIconSC>
  );
};

export default InputIcon;
